// Bus permettant de transmettre des valeurs entre les composants
import Vue from 'vue';
const EventBus = new Vue();
export default EventBus;



// WEBPACK FOOTER //
// ./src/components/bus/bus.js